import { defineComponent as _defineComponent } from 'vue'
import { User } from '@/models/User';
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import useMessengerState from '@/state/messenger/messengerState';
import { toRefs } from 'vue';
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMessengerUserBanner',
  props: {
  user: {
    type: Object as () => User,
    default: () => null,
  },
  canOpenPrivateChat: {
    type: Boolean,
  },
},
  setup(__props) {

const props = __props;



const { user } = toRefs(props);

const {
  createNewChat,
} = useMessengerState();

const startNewChat = () => createNewChat(user.value);

return { __sfc: true,props, user, createNewChat, startNewChat, BCXIcon, BCXUserBanner }
}

})